import { useState, useCallback } from 'react';

const useToast = () => {
  const [toast, setToast] = useState({
    isOpen: false,
    type: 'success',
    title: '',
    message: '',
    showCloseButton: true,
    autoClose: false,
    autoCloseDelay: 3000,
    onConfirm: null,
    onCancel: null
  });

  const showToast = useCallback((options) => {
    setToast({
      isOpen: true,
      type: options.type || 'success',
      title: options.title || '',
      message: options.message || '',
      showCloseButton: options.showCloseButton !== false,
      autoClose: options.autoClose || false,
      autoCloseDelay: options.autoCloseDelay || 3000,
      onConfirm: options.onConfirm || null,
      onCancel: options.onCancel || null
    });
  }, []);

  const hideToast = useCallback(() => {
    setToast(prev => ({ ...prev, isOpen: false }));
  }, []);

  const showSuccess = useCallback((message, title = 'Éxito') => {
    console.log('🎉 showSuccess llamado:', { message, title });
    showToast({ type: 'success', title, message, autoClose: true, autoCloseDelay: 3000 });
  }, [showToast]);

  const showError = useCallback((message, title = 'Error') => {
    showToast({ type: 'error', title, message, autoClose: true, autoCloseDelay: 5000 });
  }, [showToast]);

  const showWarning = useCallback((message, title = 'Advertencia') => {
    showToast({ type: 'warning', title, message });
  }, [showToast]);

  const showInfo = useCallback((message, title = 'Información') => {
    showToast({ type: 'info', title, message });
  }, [showToast]);

  const showConfirm = useCallback((message, title = 'Confirmar', options = {}) => {
    showToast({ 
      type: 'warning', 
      title, 
      message, 
      showCloseButton: true,
      autoClose: false,
      onConfirm: options.onConfirm,
      onCancel: options.onCancel
    });
  }, [showToast]);

  const handleConfirm = useCallback(() => {
    if (toast.onConfirm) {
      toast.onConfirm();
    }
    hideToast();
  }, [toast.onConfirm, hideToast]);

  const handleCancel = useCallback(() => {
    if (toast.onCancel) {
      toast.onCancel();
    }
    hideToast();
  }, [toast.onCancel, hideToast]);

  return {
    toast,
    showToast,
    hideToast,
    showSuccess,
    showError,
    showWarning,
    showInfo,
    showConfirm,
    handleConfirm,
    handleCancel
  };
};

// Mantener compatibilidad con el nombre anterior
const usePopup = useToast;

export { usePopup };
export default usePopup;
